import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {CardModule} from '../../../../../../core/component/card/card.module';
import {CreateUpdateDefaultModule} from '../../../../../../core/component/create-update-default/create-update-default.module';
import {FormFieldModule} from '../../../../../../core/component/form-field/form-field.module';
import {LovValueSelectFilterModule} from '../../../../../../common/lov/lov-value/api/component/lov-value-select-filter/lov-value-select-filter.module';
import {DatePickerModule} from '../../../../../../../components/common/date-picker/date-picker.module';
import {SaleInvoiceSaveComponent} from './sale-invoice-save.component';
import {RichTextEditorModule} from '../../../../../../../components/common/rich-text-editor/rich-text-editor.module';
import {DocumentCreateFormModule} from '../../../../../../document/common/api/component/document-create-form/document-create-form.module';
import {NumberInputModule} from '../../../../../../../components/common/number/number-input/number-input.module';
import {SaleSummaryFieldModule} from '../../../../../api/component/sale-summary-field/sale-summary-field.module';
import {ViewByIdDefaultModule} from '../../../../../../core/component/view-by-id-default/view-by-id-default.module';
import {ViewByAttributeModule} from '../../../../../../core/component/view-by-attribute/view-by-attribute.module';
import {SaleInvoiceReportOptionsInputFormModule} from '../sale-invoice-report-options-input-form/sale-invoice-report-options-input-form.module';
import {
    DocumentDownloadModule
} from '../../../../../../document/common/api/component/document-download/document-download.module';
import {InputTextModule} from "../../../../../../core/component/input-text/input-text.module";
import {SelectModule} from "../../../../../../../components/common/select/select.module";
import {CardV2Component} from "../../../../../../core/component/card-v2/card-v2.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        CardModule,
        ReactiveFormsModule,
        CreateUpdateDefaultModule,
        FormFieldModule,
        LovValueSelectFilterModule,
        DatePickerModule,
        RichTextEditorModule,
        DocumentCreateFormModule,
        NumberInputModule,
        SaleSummaryFieldModule,
        ViewByAttributeModule,
        ViewByIdDefaultModule,
        SaleInvoiceReportOptionsInputFormModule,
        DocumentDownloadModule,
        InputTextModule,
        SelectModule,
        CardV2Component,
    ],
    declarations: [SaleInvoiceSaveComponent],
    // providers: [ProductSaveCRUDService],
    exports: [
        SaleInvoiceSaveComponent
    ]
})
export class SaleInvoiceSaveModule {
}
